<template>
	<div class="ld-panel-title">
		<router-link to="/hosts" class="back-btn"><span></span>升级实例</router-link>
	</div>
	<div class="ld-panel-main" v-loading="fullscreenLoading">
		<el-alert title="所有的配置只能升级，不支持降级，降级配置可提交工单进行处理!" type="warning" show-icon :closable="false" style="margin-bottom: 20px;" />
		<el-descriptions title="当前配置信息" :column="4" border>
			<el-descriptions-item label="实例规格">{{detailData.cpu}}核{{detailData.memory}}G</el-descriptions-item>
			<el-descriptions-item label="数据容量">{{detailData.disks}}G</el-descriptions-item>
			<el-descriptions-item label="IOPS">{{detailData.bandwidth}}</el-descriptions-item>
			<el-descriptions-item label="系统版本">{{detailData.version}}</el-descriptions-item>
		</el-descriptions>
		<div v-if="showStatus">
			<el-table ref="tableRef" :data="tableData" highlight-current-row style="width: 100%" @current-change="handleCurrentChange">
				<el-table-column width="50">
					<span class="icon"></span>
				</el-table-column>
				<el-table-column label="规格">
					<template #default="scope">
						<div>{{scope.row.product_name}}</div>
					</template>
				</el-table-column>
				<el-table-column sortable prop="cpu" label="CPU" />
				<el-table-column sortable prop="memory" label="内存" />
				<el-table-column prop="iops" label="最大IOPS" />
				<el-table-column sortable prop="price" label="价格 / 月" />
			</el-table>
			<el-form :label-width="formLabelWidth" style="margin-top: 20px;">
				<!-- <el-form-item label="公网带宽:" v-if="enable == 2">
					<el-input-number v-model="bandwidth" :min=minNum :max="30" :disabled="bandwidthDisabled" @change="bandwidthChange" controls-position="right" />
				</el-form-item> -->
				<el-form-item label="到期日期:"><el-text>{{expirationTime}}</el-text></el-form-item>
				<el-form-item label="升级差价:">
					<el-text size="large" style="color: #ff6600;">{{price}}元</el-text>
				</el-form-item>
				<el-form-item label="当前余额:">
					<el-text style="color: #ff6600;" size="large">{{balance}}元</el-text>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm">确认提交</el-button>
				</el-form-item>
			</el-form>
		</div>
		<dl class="otherData" v-else>
			<dt style="color: #ff4c4f;">您当前已是最高规格配置，不支持升级，可咨询其他配置<a href="https://www.landui.com/index/index/qq.html" target="_blank" class="btn">咨询客服</a></dt>
			<dd>
				<span>多区域多节点</span>
				<span>高性能高可用</span>
				<span>灵活扩展、定制化部署</span>
				<span>数据安全</span>
				<span>满足合规要求</span>
				<span>多种RDS数据库可选择</span>
			</dd>
		</dl>
	</div>
</template>

<script setup>
	import { ref,reactive,inject,onMounted } from 'vue';
	import { useRouter } from 'vue-router';
	import { fetchDetail,upgradeSpec,upgradePrice,upgradeOrder } from '@/api/host';
	import { ElMessage, ElMessageBox } from 'element-plus';
	
	const domain = inject('domain');
	const router = useRouter();
	const enable = ref(1)
	const Id = ref('');
	const price = ref('0.00');
	const balance = ref('');
	const bandwidth = ref(0)
	const minNum = ref(0)
	const tableData = ref();
	const tableRef = ref(null);
	const detailData = ref('');
	const currentRow = ref('');
	const formLabelWidth = ref('80');
	const expirationTime = ref('');
	const productId = ref('');
	const bandwidthDisabled = ref(false);
	const showStatus = ref(true);
	const fullscreenLoading = ref(true);
	
	const gernaData = () => {
		const param = {'instance_id':Id.value}
		fetchDetail(param).then((res) => {
			detailData.value = res.data;
		})
		upgradeSpec(param).then((res) => {
			if (res.code == 200) {
				balance.value = res.data.user_info.balance;
				expirationTime.value = getDateF(res.data.instance.expiration_time);
				tableData.value = res.data.product_list;
				if (res.data.product_list.length > 0) {
					tableRef.value.setCurrentRow(res.data.product_list[0]);
					productId.value = res.data.product_list[0].product_id;
				}else{
					showStatus.value = false
				}
				if (res.data.instance.enable_public_network == 2) {
					enable.value = 2;
					bandwidth.value = res.data.instance.public_network_bandwidth;
					minNum.value = res.data.instance.public_network_bandwidth;
					bandwidthDisabled.value = res.data.instance.public_network_bandwidth == 30 ? true : false;
				}
				fullscreenLoading.value = false
			}
		});
	};
	const handleCurrentChange = (val) => {
		currentRow.value = val;
		productId.value = val.product_id;
		priceF(val.product_id)
	}
	const bandwidthChange = (key) => {
		bandwidth.value = key;
		priceF(productId.value)
	};
	const priceF = (id) => {
		const param = {'instance_id':Id.value,'product_id':id};
		if (enable.value == 2) {
			param['public_network_bandwidth'] = bandwidth.value;
		}
		upgradePrice(param).then((res) => {
			price.value = parseFloat(res.data).toFixed(2);
		});
	}
	const submitForm = () => {
		const param = {'instance_id':Id.value,'product_id':productId.value};
		if (enable.value == 2) {
			param['public_network_bandwidth'] = bandwidth.value;
		}
		ElMessageBox.confirm(
			'升级实例，当前实例将进行重启，是否确认升级？',
			'提示',
			{
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				showClose:false,
				type: 'warning',
			}
		)
		.then(() => {
			upgradeOrder(param).then((res) => {
				if (res.code == 200) {
					if (res.data == '') {
						ElMessageBox.alert('下单失败', '温馨提示', {
							customClass: 'error-box',
							showConfirmButton: false,
							callback: action => {
							      
							}
						})
					} else{
						window.location.href = domain+"/user/orders/changestype.html?id="+res.data;
					}
				}
			});
		})	
		.catch(() => {
			
		})
	}
	const getDateF = (string) => {
		var date = new Date(string);
		var year = date.getFullYear();
		var month = date.getMonth() + 1;
		var day = date.getDate();
		var hours = date.getHours();
		var minute = date.getMinutes();
		let second = date.getSeconds();
		month = month < 10 ? "0" + month : month;
		day = day < 10 ? "0" + day : day;
		hours = hours < 10 ? "0" + hours : hours;
		minute = minute < 10 ? "0" + minute : minute;
		second = second < 10 ? "0" + second : second;
		var currentdate = year + "-" + month + "-" + day + " " + hours + ":" + minute + ":" + second;
		return currentdate
	}
	
	onMounted(() => {
		if(router.currentRoute.value.query){
			Id.value = router.currentRoute.value.query.id;
		}
		gernaData()
	})
	
</script>

<style lang="scss" scoped>
	.otherData{ 
		width: 100%; 
		border: 1px solid #ebeef5;
		margin-bottom: 16px; 
		overflow: hidden;
		dt{background-color: #ecf5ff;padding: 10px 20px; line-height: 40px; font-size: 14px;overflow: hidden;}
		dd{
			line-height: 70px;
			text-align: center; 
			overflow: hidden;
			span{ margin:0 20px; padding-left: 25px;background: url(../../assets/images/no.png) left center no-repeat;}
		}
		.btn{ width: 140px;height:40px; line-height: 40px;font-size: 14px;text-align: center; color: #fff; border-radius: 0;background-color: #ff8a00; float: right; cursor: pointer;}
		.btn:hover{ background:#fb8b2a;}
	} 
	.icon{ display: block; width: 16px;height: 16px;background: url(../../assets/images/radio-normal.png) center no-repeat;}
	.current-row .icon{background: url(../../assets/images/radio-checked.png) center no-repeat;}
	.head{
		margin-bottom: 30px;
		overflow: hidden;
		p{margin-top:10px;font-size: 12px;color: #a0a2a3;}
	}
	.price{margin: 20px 0;overflow: hidden;}
	::v-deep(.el-descriptions__label) {width: 110px;}
</style>